import {Pipe, PipeTransform} from '@angular/core';
import {StockProductDto} from '../../../Models/Warehouse/Stocks/stock.interface';

@Pipe({
  name: 'stocks',
  standalone: false
})
export class StocksPipe implements PipeTransform {

  transform(items: StockProductDto[], filter: { families?: number[], isRequired?: boolean }): StockProductDto[] {

    if (!items.length) {
      return [];
    }

    if (filter?.families?.length) {
      items = items.filter((item) => filter.families?.includes(item.id_familia_pricipal));
    }

    if (filter?.isRequired) {
      items = items.filter((item) => item.is_required);
    }

    return items;

  }

}
